import { styled } from 'styled-components';

export const Title = styled.h5`
  margin-bottom: var(--spacing-tiny);
`;
